import { gql } from '@apollo/client';

export const SEND_REFERRAL_EMAIL = gql`
  query SEND_REFERRAL_EMAIL(
    $recipientEmail: String!
    $referrerInfo: TmpSoarEmails_ReferrerInfo!
    $employerInfo: TmpSoarEmails_EmployerInfo!
  ) {
    tmpSoarEmails_createEmailEvent(
      recipientEmail: $recipientEmail
      referrerInfo: $referrerInfo
      employerInfo: $employerInfo
    ) {
      status
      body
    }
  }
`;
